import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatAutocomplete, MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { IDisposable } from "core/dynamic-form";
import { filterAllTruthyInTuple } from "core/rx-js";
import { BehaviorSubject, Subject, combineLatest, distinctUntilChanged, fromEvent, map, merge, takeUntil } from "rxjs";
import { SignatureOptionsService } from "../signature-options.service";


@Component({
  selector: 'ss-batch-autocomplete',
  templateUrl: './batch-autocomplete.component.html',
  styleUrls: ['./batch-autocomplete.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatchAutocompleteComponent implements OnInit {

  private readonly _destroy = new Subject<void>();
  private readonly _disposables: IDisposable[] = [];

  readonly inputTextSubject = new BehaviorSubject<string>('')

  @ViewChild('inputRef')
  private _inputRef!: ElementRef<HTMLInputElement>

  @ViewChild('autocompleteRef')
  private _autcompleteRef!: MatAutocomplete

  @ViewChild(MatAutocompleteTrigger)
  private _autocompleteTrigger!: MatAutocompleteTrigger;


  get signatureTask() {
    return this._signatureOptionService.signatureTask;
  }

  readonly batchNameSubject = this._signatureOptionService.batchNameSubject
  readonly hangingValueSubject = new BehaviorSubject<string>(undefined)

  readonly activityBatchesObs = combineLatest([
    this._signatureOptionService.activityBatchesObs,
    this.hangingValueSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      map(([activityBatches, hangingValue]) => activityBatches.filter((currentBatch) => currentBatch?.toLowerCase()?.includes(hangingValue?.toLowerCase()) || !hangingValue))
    )

  readonly batchReadonlyObs = this._signatureOptionService.batchReadonlyObs;

  constructor(
    private _signatureOptionService: SignatureOptionsService
  ) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

    merge(
      fromEvent(this._inputRef.nativeElement, 'change'),
      fromEvent(this._inputRef.nativeElement, 'keyup'),
      this._autcompleteRef.optionSelected
    ).pipe(
      takeUntil(this._destroy),
      map(() => this._inputRef.nativeElement.value),
      distinctUntilChanged()
    )
      .subscribe((value) => {
        this.hangingValueSubject.next(value);
        this.batchNameSubject.next(value)
      })

  }

  save() {

    const batchName = this._inputRef.nativeElement.value;
    this.batchNameSubject.next(batchName);
  }

  clear(ev: Event) {
    ev.stopPropagation();
    this._inputRef.nativeElement.value = '';

  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();

    const hangingValue = this.hangingValueSubject.value;
    const value = this.batchNameSubject.value;

    if (hangingValue !== value) {
      this.batchNameSubject.next(hangingValue);
    }

    this._disposables.forEach(d => d.dispose())

  }
}

